"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightContent = exports.LeftContent = exports.Attribution = exports.ContentWrapper = exports.StyledDropdownButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DropdownButton = _interopRequireDefault(require("../../../Buttons/DropdownButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Ours
var StyledDropdownButton = (0, _styledComponents.default)(_DropdownButton.default).withConfig({
  displayName: "AnnotatedSuggestionRowstyles__StyledDropdownButton",
  componentId: "sc-47ny5b-0"
})(["", ""], function (props) {
  return props.isAttribution ? "border-top: ".concat(props.theme.thinLine, " solid") : null;
});
exports.StyledDropdownButton = StyledDropdownButton;

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "AnnotatedSuggestionRowstyles__ContentWrapper",
  componentId: "sc-47ny5b-1"
})(["display:flex;justify-content:space-between"]);

exports.ContentWrapper = ContentWrapper;

var Attribution = _styledComponents.default.div.withConfig({
  displayName: "AnnotatedSuggestionRowstyles__Attribution",
  componentId: "sc-47ny5b-2"
})(["justify-content:flex-end;display:flex;font-family:", ";font-size:", ";font-weight:", ";"], function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.theme.primaryHeavy;
});

exports.Attribution = Attribution;

var LeftContent = _styledComponents.default.div.withConfig({
  displayName: "AnnotatedSuggestionRowstyles__LeftContent",
  componentId: "sc-47ny5b-3"
})([""]);

exports.LeftContent = LeftContent;

var RightContent = _styledComponents.default.div.withConfig({
  displayName: "AnnotatedSuggestionRowstyles__RightContent",
  componentId: "sc-47ny5b-4"
})(["font-weight:", ";"], function (props) {
  return props.theme.secondaryNormal;
});
/*
width: 100%;
  text-align: left;
  border-radius: 0;
  margin: 0;
  margin-bottom: ${props => props.theme.thinLine};
  padding: ${props => props.theme.standardPadding};


  // This is needed to overwrite some of the button styling
  &, & * {
    font-family: ${props => props.theme.primaryFont};
  }
  &.c-annotated-suggestion-row-active,
  &.c-annotated-suggestion-row-active *,
  &:hover,
  &:hover * {
    ${inputDropdownItem}

    .c-annotated-suggestion-primary-text {
       color: ${props => props.theme.c_foreground_default}
    }
    .c-annotated-suggestion-secondary-text {
       color: ${props => props.theme.c_foreground_overDark}
    }
  }

  .c-annotated-suggestion-label-container {
    display: flex;
    justify-content: space-between;
  }

  .c-annotated-suggestion-primary-text {
    font-size: ${props => props.theme.fontMediumSmall};
    font-weight: ${props => props.theme.primaryNormal};
  }

  .c-annotated-suggestion-secondary-text {
    font-size: 1rem;
    font-weight: ${props => props.theme.primaryHeavy};
    color: ${props => props.theme.c_clickable_primaryGhost_active_background};
  }
 */


exports.RightContent = RightContent;